import { AbstractCommand } from 'src/models/command';

class DearchiveTheSelectedAggregateIdsCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Desktop_Actions_DearchiveTheSelectedAggregateIds';

	public constructor(aggregateIds: string[]) {
		super();
		this.parameters = {
			aggregateIds: aggregateIds,
		};
	}
}

export { DearchiveTheSelectedAggregateIdsCommand };
